export function validateImage(file: File): { valid: boolean; message?: string } {
  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
  const maxSize = 2 * 1024 * 1024; // 2MB

  if (!allowedTypes.includes(file.type)) {
    return { valid: false, message: '仅支持 JPG、PNG、WebP 格式' };
  }

  if (file.size > maxSize) {
    return { valid: false, message: '图片大小不能超过 2MB' };
  }

  return { valid: true };
}

export function compressImage(
  file: File,
  options: { maxWidth?: number; quality?: number } = {}
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const { maxWidth = 1080, quality = 0.8 } = options;
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject(new Error('压缩失败'));
          },
          file.type,
          quality
        );
      };
      img.onerror = reject;
      img.src = e.target?.result as string;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
